import { Component, OnInit } from '@angular/core';
import { BasePageComponent } from '../../pages/base.page';

@Component({
    selector: 'aumico-invitation-expired',
    templateUrl: './invitation-expired.component.html',
    styleUrls: ['./invitation-expired.page.scss'],
})
export class InvitationExpiredPage extends BasePageComponent implements OnInit {}
